<template>
  <artmisads-modal
    v-model:open="visible"
    title="Add Brand to Blacklist"
    :width="500"
    :destroyOnClose="false"
    :maskClosable="false"
    :footer="null"
    :onCancel="onCancelClose"
  >
    <div class="content">
      <div class="content-item" ref="marketplaceRef">
        <div class="content-item-title">
          Marketplace
        </div>
        <div class="content-item-input">
          <artmisads-select
            v-model:value="filter.marketplace"
            style="width: 232px"
            :options="marketplaceOptions"
            :show-arrow="false"
            placeholder="Select Marketplace"
            :getPopupContainer="() => marketplaceRef"
            @change="handleMarketplaceChange"
          />
        </div>
      </div>
      <div class="content-item" ref="brandRef">
        <div class="content-item-title">
          Brand Name
        </div>
        <div class="content-item-input">
           <artmisads-select show-search v-model:value="filter.brandId" style="width: 232px" :options="brandOptions"
          @search="searchBrand" :show-arrow="false" :filter-option="false" :not-found-content="null" placeholder="All"
          allowClear @change="handleBrandChange"  :getPopupContainer="() => brandRef"/>

        </div>
      </div>
      <div class="btn-box">
        <artmisads-button type="primary" @click="handleConfirm"
          >Confirm</artmisads-button
        >
      </div>
    </div>
  </artmisads-modal>
</template>
<script setup lang="jsx">
import { ref, defineEmits, defineExpose } from 'vue'
import { COUNTRY_BASE } from '~/contants/common'
import { publisherAdminApi } from '~/server/index'
import { message } from "ant-design-vue";

const visible = ref(false)
const brandOptions = ref([])
const marketplaceRef = ref(null)
const brandRef = ref(null)
const marketplaceOptions = COUNTRY_BASE
  .filter((item) => item.host !== 'amazon.de' && item.host !== 'amazon.fr')
  .map((item) => ({
    label: item.host,
    value: item.host,
  }))
const filter = ref({
  marketplace: '',
  brandId:'',
  brandName:'',
})
const emits = defineEmits(['refreshList'])
const resetFilter = () => {
  filter.value.marketplace = ''
  filter.value.brandId = ''
  filter.value.brandName = ''
  brandOptions.value = []
}
const open = () => {
  visible.value = true
  resetFilter()
}
const onCancelClose = () => {
  visible.value = false
  resetFilter()
}
const handleMarketplaceChange = () => {
  filter.value.brandId = ''
  filter.value.brandName = ''
  brandOptions.value = []
}
const searchBrand = async keyword => {
  let res, params
   params = {
      keyword,
      marketplace: filter.value.marketplace || 'amazon.com'
    };
   res= await publisherAdminApi.searchBrand(params);
      res = res.map(item => {
      // 检查是否存在重复的 amazonBrandName
      const hasDuplicate = res.some(otherItem => 
        otherItem.amazonBrandName === item.amazonBrandName && 
        otherItem.id !== item.id
      );

      return {
        ...item,
        label: hasDuplicate ? `${item.amazonBrandName} (${item.amazonProfileAccountInfoName})` : item.amazonBrandName,
        value: item.id
      };
    })
    brandOptions.value = res
}
const handleConfirm = async () => {
  if (!filter.value.marketplace) {
    message.error('Please select a marketplace')
    return
  }
  if (!filter.value.brandId) {
    message.error('Please select a brand')
    return
  }
  const res = await publisherAdminApi.addWhitelist({
    brandName: filter.value.brandName,
    marketplace: filter.value.marketplace,
  })
  if (res.success) {
    message.success('Add success')
    emits('refreshList')
    visible.value = false
  }
}
const handleBrandChange = (value) => {

 const brandObj = brandOptions.value.find(item => item.value === value)
 if (value) {
  filter.value.brandName = brandObj.amazonBrandName
 }
}
// 暴露方法给父组件
defineExpose({
  open,
})
</script>
<style scoped lang="less">
  .content-item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    .content-item-title {
      width: 100px;
      flex-shrink: 0;
    }
  }
  .btn-box{
   margin-top: 20px;
   display: flex;
   align-items: center;
   justify-content: flex-end;
  }
</style>
